import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__left" }
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = { class: "text--highlight" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "text--highlight" }
const _hoisted_7 = { class: "header__subtitle" }
const _hoisted_8 = { class: "header__right" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.content.firstName), 1),
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.content.lastName), 1)
      ]),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.content.professionalTitle), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("p", null, _toDisplayString(_ctx.content.location), 1),
      _createElementVNode("p", null, [
        _createElementVNode("a", {
          href: `mailto:${_ctx.content.email}`
        }, _toDisplayString(_ctx.content.email), 9, _hoisted_9)
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("a", {
          href: `${_ctx.content.website}`
        }, _toDisplayString(_ctx.content.website), 9, _hoisted_10)
      ])
    ])
  ]))
}